<nz-table #expandTable [nzData]="tableData.length ? tableData : ['']" [nzScroll]="{ x: '900px', y: '370px'}"
  [nzOuterBordered]="true" class="pivot-table" [nzBordered]="true" [nzFrontPagination]="false" [nzShowPagination]="true"
  [nzPaginationType]="'default'" [nzTableLayout]="'fixed'" [nzLoading]="tableConfig.isLoading" nzSize="small"
  [nzShowTotal]="tableConfig.tableLevel == 1 ? tableTotal : false" [nzPageSize]="tableConfig.limit"
  [nzTotal]="tableConfig.tableTotalCount" (nzPageIndexChange)="onPagechange($event)">
  <thead>
    <tr>
      <!-- <th *ngIf="tableConfig.hasSubLevels" nzWidth="20px"></th> -->
      @for (column of tableConfig.tableColumns; track column) {
        <th [nzAlign]="'left'" [nzWidth]="'200px'">
          {{ column.label }}
        </th>
      }
    </tr>
  </thead>
  @if (tableData.length) {
    <tbody>
      @for (row of tableData; track row; let i = $index; let last = $last) {
        <tr [class]="'level-' + row.level" [style]="{'text-align': 'left'}">
          <!-- <td *ngIf="tableConfig.hasSubLevels && row.expand" class="expand-icon" [nzShowExpand]="row.expand"
          [(nzExpand)]="row.expanded" (nzExpandChange)="onExpandTable($event, row, i)">
        </td> <td *ngIf="tableConfig.hasSubLevels && !row.expand">
      </td> -->
      @for (header of tableConfig.tableColumns; track header; let f = $first; let l = $last) {
        @if (f) {
          <td
            [style]="{'padding-left': row.level == 1 ? '0.25rem' : row.level == tableConfig.maxLevel ? (row.level)+ 'rem' : (row.level - 1) + 'rem', 'padding-right': l ? row.level == tableConfig.maxLevel ? '0.25rem' : (tableConfig.maxLevel - row.level) + 'rem' : '0'}"
            class="table-cell">
            <div [style]="{'display': 'inline-flex', 'vertical-align': 'middle', 'margin-right': '0.3rem'}">@if (tableConfig.hasSubLevels && row.expand && !row.expanded) {
              <span
                nz-icon nzType="plus" nzTheme="outline" [style.color]="'black'"
              (click)="onExpandTable($event, row, i); row.expanded = true"></span>
            }
            @if (tableConfig.hasSubLevels && row.expand && row.expanded) {
              <span nz-icon nzType="minus" nzTheme="outline" [style.color]="'black'"
              (click)="onCollapseTable($event, row, i); row.expanded = false"></span>
            }
          </div>
          <div [style]="{'display': 'inline-flex', 'vertical-align': 'middle'}"
            title="{{ row.dataColumns[header.value] }}">
          {{ row.dataColumns[header.value] }}</div>
        </td>
      }
      @if (!f) {
        <td
          [style]="{'padding-left': '8px', 'padding-right': l ? row.level == tableConfig.maxLevel ? '0.25rem' : (tableConfig.maxLevel - row.level)+ 'rem' : 0}"
          class="table-cell" title="{{ row.dataColumns[header.value] }}">
        {{ row.dataColumns[header.value] }}</td>
      }
    }
  </tr>
  @if (row.subLevelData) {
    <tr [nzExpand]="row.expanded" class="table-row-panel">
      <app-config-table [tableData]="row.subLevelData" [tableConfig]="row.subLevelTableConfig"
      [parentLevelData]="row"></app-config-table>
    </tr>
  }
}
</tbody>
}
</nz-table>

<ng-template #tableTotal let-range="range" let-total>
  Showing {{ range[0].toLocaleString() }} -
  {{ range[1].toLocaleString() }} of {{ total.toLocaleString() }} Records
</ng-template>